import BuyerCardsView from "./BuyerCardsView";

export default BuyerCardsView;
